<template>
    <div>
        <div v-if="classScheduleData.length===0" class="alert alert-warning">没有教学安排数据，请添加</div>
        <table v-else class="table table-bordered">
            <thead>
            <tr>
                <th class="text-center align-middle" colspan="2">日期</th>
                <th class="text-center align-middle" style="width: 24%">课程名称</th>
                <th class="text-center align-middle" style="width: 25%">课程内容</th>
                <th class="text-center align-middle" style="width: 8%">讲师</th>
                <th class="text-center align-middle" style="width: 8%">课时</th>
                <th class="text-center align-middle" style="width: 10%">授课地点</th>
                <th class="text-center align-middle" style="width: 10%">编辑</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(schedule, index) in classScheduleData" :key="schedule.scheduleId">
                <td class="text-center align-middle" style="width: 10%">{{schedule.trainDateString}}</td>
                <td class="text-center align-middle" style="width: 5%">{{schedule.trainDatePartName}}</td>
                <td class="text-left align-middle">{{schedule.courseName}}</td>
                <td class="text-left align-middle">{{schedule.trainContent}}</td>
                <td class="text-center align-middle">{{schedule.personName}}</td>
                <td class="text-center align-middle">{{schedule.trainLength}}</td>
                <td class="text-center align-middle">{{schedule.classRoom}}</td>
                <td class="text-center align-middle">
                    <button class="btn btn-primary btn-sm mr-2" @click="btnEditScheduleInfo_Click(index)">编辑</button>
                    <button class="btn btn-danger btn-sm " @click="btnDeleteScheduleInfo_Click(schedule.scheduleId)">删除</button>
                </td>
            </tr>
            </tbody>
        </table>
        <div>
            <button class="btn btn-primary mr-2" @click="btnAddScheduleInfo_Click">添加教学日程安排</button>

            <a :href="URL_API + '//export/classScheduleTemplate?projectId=' + projectId" class="btn btn-info mr-2">下载日程安排导入模板</a>
            <button class="btn btn-info" @click="btnUploadClassScheduleData_Click">导入教学日程安排</button>
            <input type="file" name="uploadFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                   style="display: none" ref="uploadFile" @change="uploadFileChange">
        </div>


        <b-modal v-model="isEditClassScheduleInfoDialogOpen" @ok="editClassScheduleInfoDialog_OK"
                 :title="isInsertClassScheduleInfo?'添加教学日程安排信息':'编辑教学日程安排信息'"
                 ok-title="确定" cancel-title="取消" size="lg"
                 :no-close-on-backdrop="true">
            <div class="form-group row">
                <label class="col-sm-2 col-form-label text-right" for="inputTrainDate">授课日期</label>
                <div class="col-sm-6">
                    <input type="date" class="form-control" id="inputTrainDate" v-model="editClassScheduleInfo.trainDate">
                </div>
                <div class="col-sm-3">
                    <select class="form-control" id="inputTrainDatePart" v-model.number="editClassScheduleInfo.trainDatePart">
                        <option v-for="code in scheduleDatePartEnum" :key="code.codeValue" :value="code.codeValue">{{code.codeContent}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label text-right" for="inputCourseTrainer">课程及讲师</label>
                <div class="col-sm-9">
                    <select class="form-control" id="inputCourseTrainer" v-model="editClassScheduleInfo.courseTeacherId">
                        <option value="">（请选择）</option>
                        <optgroup label="通识类课程">
                            <option v-for="ct in projectCommonTeacherCourseData" :key="ct.pkId" :value="ct.courseTeacherId">{{ct.courseName}} - {{ct.personName}}</option>
                        </optgroup>
                        <optgroup label="自定义类课程">
                            <option v-for="ct in projectTeacherCourseData" :key="ct.courseTeacherId" :value="ct.courseTeacherId">{{ct.courseName}} - {{ct.personName}}</option>
                        </optgroup>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label text-right" for="inputTrainContent">课程内容</label>
                <div class="col-sm-9">
                    <textarea class="form-control" id="inputTrainContent" v-model="editClassScheduleInfo.trainContent" rows="3"></textarea>
                </div>
            </div>
            <div class="form-group row mb-0">
                <label class="col-sm-2 col-form-label text-right" for="inputTrainLength">课时</label>
                <div class="col-sm-3">
                    <input type="number" class="form-control" id="inputTrainLength" v-model.number="editClassScheduleInfo.trainLength" >
                </div>
                <label class="col-sm-2 col-form-label text-right" for="inputClassRoom">授课地点</label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" id="inputClassRoom" v-model="editClassScheduleInfo.classRoom" >
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import url from "@/utils/api/url";
import baseApi from "@/utils/api/base";
import projectApi from "@/utils/api/project";
import commonApi from "@/utils/api/common";
import userApi from "@/utils/api/user";

export default {
    name: "ProjectClassScheduleEdit",
    props: {
        projectId: {type: String, required: true},
        classId: {type: String, required: true},
    },
    data: function () {
        return {
            URL_API: url.URL_API,

            scheduleDatePartEnum: [],
            projectTeacherCourseData: [],
            projectCommonTeacherCourseData: [],
            classScheduleData: [],

            editClassScheduleInfo: {
                scheduleId: '',
                classId: this.classId,
                courseTeacherId: '',
                trainDate: '',
                trainDatePart: 1,
                trainContent: '',
                classRoom: '',
                trainLength: 4
            },
            isInsertClassScheduleInfo: true,
            isEditClassScheduleInfoDialogOpen: false,
        };
    },
    mounted() {
        this.getScheduleDatePartEnum();
        this.getProjectTeacherCourseData();
        this.getProjectCommonTeacherCourseData();
        this.getClassScheduleData();
    },
    methods: {
        getScheduleDatePartEnum() {
            baseApi.codeValue.getProjectClassScheduleDatePartEnum().then(res => {
                this.scheduleDatePartEnum = res.data;
            });
        },
        getProjectTeacherCourseData() {
            projectApi.project.teacherCourse.getProjectTeacherCourseData(this.projectId).then(res => {
                this.projectTeacherCourseData = res.data;
            });
        },
        getProjectCommonTeacherCourseData() {
            projectApi.project.teacherCourse.common.getProjectCommonTeacherCourseData(this.projectId).then(res => {
                this.projectCommonTeacherCourseData = res.data;
            });
        },
        getClassScheduleData() {
            projectApi.class.schedule.getProjectClassScheduleData(this.classId).then(res => {
                this.classScheduleData = res.data;
            });
        },

        btnAddScheduleInfo_Click() {
            this.editClassScheduleInfo = {
                scheduleId: '',
                classId: this.classId,
                courseTeacherId: '',
                trainDate: '',
                trainDatePart: 1,
                trainContent: '',
                classRoom: '',
                trainLength: 4
            };
            this.isInsertClassScheduleInfo = true;
            this.isEditClassScheduleInfoDialogOpen = true;
        },
        btnEditScheduleInfo_Click(index) {
            let info = this.classScheduleData[index];
            this.editClassScheduleInfo = {
                scheduleId: info.scheduleId,
                classId: this.classId,
                courseTeacherId: info.courseTeacherId,
                trainDate: info.trainDateString,
                trainDatePart: info.trainDatePart,
                trainContent: info.trainContent,
                classRoom: info.classRoom,
                trainLength: info.trainLength
            };
            this.isInsertClassScheduleInfo = false;
            this.isEditClassScheduleInfoDialogOpen = true;
        },
        editClassScheduleInfoDialog_OK() {
            if (this.isInsertClassScheduleInfo) {
                projectApi.class.schedule.insertProjectClassScheduleInfo(this.editClassScheduleInfo).then(res => {
                    this.getClassScheduleData();
                });
            }
            else {
                projectApi.class.schedule.updateProjectClassScheduleInfo(this.editClassScheduleInfo).then(res => {
                    this.getClassScheduleData();
                });
            }
        },
        btnDeleteScheduleInfo_Click(scheduleId) {
            if (confirm('删除此项日程？')) {
                projectApi.class.schedule.deleteProjectClassScheduleInfo(scheduleId).then(res => {
                    this.getClassScheduleData();
                });
            }
        },


        btnUploadClassScheduleData_Click() {
            this.$refs.uploadFile.click();
        },
        uploadFileChange($event) {
            let file = $event.target.files[0];
            commonApi.file.uploadFile(file, 'ImportData').then(result => {
                let info = {
                    fileName: result.data.physicalAddress,
                    classId: this.classId,
                    projectId: this.projectId
                };

                projectApi.class.schedule.importProjectClassScheduleData(info).then(res => {
                  for (let i = 0; i < res.data.length; i++) {
                    if (res.data[i].errorMsg === '日期格式错误') {
                      alert('导入教学日程安排失败！请导入正确的模版');
                      this.$refs.uploadFile.value = ''
                      return
                    }
                  }
                  if(res.data){
                    alert('导入教学日程安排成功！');
                    this.$refs.uploadFile.value = ''
                  }
                  this.getClassScheduleData();
                });
            });
        }
    }
}
</script>

<style scoped>

</style>
